import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WebServiceService } from '../../shared/services/web-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-dynamic-vendor-po-bar-chart',
  templateUrl: './dynamic-vendor-po-bar-chart.component.html',
  styleUrls: ['./dynamic-vendor-po-bar-chart.component.scss']
})
export class DynamicVendorPoBarChartComponent implements OnInit {

  @Input() labels: string[];
  @Input() data: number[];
  @Input() barChartType?: string = 'bar';
  @Input() colors?: any = ['red', 'bule', 'red', 'bule', 'red', 'bule', ]
  @Input() barlineChartLegend?:boolean=true;
  @Input() title:any;
  ChartLegend:boolean=true;

  lineChartColors: any;
  barChartPlugins = [];

  public options: any = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    },
    scales: {
      xAxes: [{
          gridLines: {
              color: "rgba(0, 0, 0, 0)",
          }
      }],
      yAxes: [{
          gridLines: {
              color: "rgba(0, 0, 0, 0)",
          }  
          ,
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            // Create scientific notation labels
            callback: function(value, index, values) {
              // console.log(value)
              // console.log(index)
              // console.log(values)
                return value + ' K';
            }
        } 
      }]
  }
  }
  constructor(private router: Router,public webService: WebServiceService,) { }

  ngOnInit() {
    this.lineChartColors = [{ backgroundColor: this.colors }];

  }
  public chartClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {  
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        const value = chart.data.datasets[0].data[clickedElementIndex];
        // this.navigateUrl(label,value);
      }
    }
  }

  chartHovered(e: any): void {
  }

  

}



// WEBPACK FOOTER //
// /codebuild/output/src1830568451/src/src/app/common/dynamic-vendor-po-bar-chart/dynamic-vendor-po-bar-chart.component.ts